import {AwardsItem} from 'Interfaces'
import {orderBy} from 'lodash'

export const Sort = (items: AwardsItem[]) =>
  orderBy(
    items,
    [(o) => o.year || 1, (o) => o.month || 0, (o) => o.title],
    ['desc', 'desc', 'asc']
  )
